import User from "@/services/UserService/user";
import ListsService from "@/services/ListsService";
export const UserStore = {
  me: undefined,
  accounts: undefined,
  accountsOptions: undefined,
  subscribers: {
    all: []
  }
};
export default class UserService {
  constructor(leanLawApi, leanLawAuth, global, currentAccountId) {
    this.global = global;
    this.leanLawApi = leanLawApi;
    this.leanLawAuth = leanLawAuth;
    this.currentAccountId = currentAccountId;
  }
  subscribe(ev, callback) {
    if (!UserStore.subscribers[ev]) {
      UserStore.subscribers[ev] = [];
    }
    UserStore.subscribers[ev].push(callback);
  }
  publish(ev) {
    if (UserStore.subscribers[ev]) {
      UserStore.subscribers[ev].forEach(callback => {
        callback();
      });
    }
  }
  getMe() {
    if (UserStore.me) {
      return UserStore.me;
    }
    UserStore.me = this.global.ready.then(() => this.leanLawApi.getMe().then(user => {
      window.leanlaw.currentAccountId = user.id;
      this.currentAccountId.value = user.id;
      return this.getMyAccounts().then(accounts => {
        // eslint-disable-next-line no-param-reassign
        user.label = user.first;
        user.accounts = accounts;
        if (accounts.length > 1) {
          // User label is shown in header and we modify it to the firm
          // name if we have multiple accounts
          user.label = user.company.name;
          if (user.label.length > 15) {
            user.label = `${user.label.substring(0, 13)}...`;
          }
        }
        const newUser = new User(this.leanLawAuth.features);
        return newUser.load(user, true);
      });
    }));
    return UserStore.me;
  }
  listUsers(options) {
    if (options) {
      if (!UserStore.accountsOptions) {
        UserStore.accountsOptions = this.leanLawApi.listAccounts(options).then(list => _.map(list.accounts, user => new User(this.leanLawAuth.features).load(user)));
      }
      return UserStore.accountsOptions;
    }
    if (!UserStore.accounts) {
      UserStore.accounts = this.leanLawApi.listAccounts().then(list => _.map(list.accounts, user => new User(this.leanLawAuth.features).load(user)));
    }
    return UserStore.accounts;
  }
  getUser(id) {
    return this.leanLawApi.getAccount({
      id
    }).then(user => new User(this.leanLawAuth.features).load(user));
  }
  create(user) {
    return this.leanLawApi.createAccount({
      body: user
    }).then(account => {
      // clear cache
      UserStore.accounts = null;
      this.publish('create');
      return account;
    });
  }
  getMyAccounts() {
    return this.leanLawApi.listMyAccounts().then(list => list.accounts);
  }
  reset() {
    UserStore.me = null;
    UserStore.accounts = null;
    UserStore.accountsOptions = null;
  }
  async subscriptionUpdate(subscription) {
    const products = {};
    if (subscription.plan) {
      products[subscription.product.leanlawProductId] = true;
    }
    const me = await UserStore.me;
    me.company.products = products;
    UserStore.me = me;
  }
  get roles() {
    return new ListsService().userRoles;
  }
  reload() {
    UserStore.me = this.leanLawApi.getMe().then(user => new User(this.leanLawAuth.features).load(user, true));
    return UserStore.me;
  }
  update(update) {
    UserStore.accounts = null;
    return this.leanLawApi.updateAccount({
      id: update.id,
      body: update
    }).then(updated => {
      new User(this.leanLawAuth.features).load(updated);
      this.publish('user');
      return update;
    });
  }
  me() {
    return this.getMe();
  }
  list(options) {
    return this.listUsers(options);
  }
  get(id) {
    return this.getUser(id);
  }
}